import api from './serviceApi'; // Import the axios instance

const LoggerIntegrationIntegrationApi = {
    /**
     * Fetch a specific LoggerIntegration entry by its ID.
     * @param {number} id - The ID of the LoggerIntegration entry.
     * @returns {Promise<Object>} - The LoggerIntegration entry data.
     */
    getLoggerIntegrationById: async (id) => {
        try {
            const response = await api.get(`/LoggerIntegration/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching LoggerIntegration by ID:', error);
            throw error;
        }
    },

    /**
     * Fetch a paginated list of LoggerIntegration entries with optional filters.
     * @param {Object} params - Query parameters such as `page`, `quantity`, `term`, `orderBy`, `include`.
     * @returns {Promise<Object>} - The paginated list of LoggerIntegration entries.
     */
    getLoggerIntegrationPaginated: async (params) => {
        try {
            const response = await api.get('/LoggerIntegration/pagged', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching paginated LoggerIntegration entries:', error);
            throw error;
        }
    },

    /**
     * Fetch LoggerIntegration entries with filters such as date range, filters, and pagination.
     * @param {Object} params - Query parameters including `dateBegin`, `dateFinal`, `filtro`, `page`, `quantity`, `orderby`, `include`.
     * @returns {Promise<Object>} - The filtered list of LoggerIntegration entries.
     */
    getLoggerIntegration: async (params) => {
        try {
            const response = await api.get('/LoggerIntegration', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching LoggerIntegration entries:', error);
            throw error;
        }
    },

    /**
     * Export customers based on filters.
     * @param {Object} params - Query parameters such as `term`, `isActive`, etc.
     * @returns {Promise<Blob>} - The exported file data.
     */
    exportLogs: async (params) => {
        try {
            const response = await api.get('/LoggerIntegration/export', {
                params
            });
            return response.data;
        } catch (error) {
            console.error('Error exporting customers:', error);
            throw error;
        }
    },
};

export default LoggerIntegrationIntegrationApi;
